export default {
  title: 'Dietary attributes',
};
